// THE HOME PAGE'S <title>, WITH THE FIGURE DERIVED AND NEVER TYPED.
//
// Until 5 October 2026 pages/home/home-page.jsx declared the title as a plain
// string with "from £69" written into it, while MetaTags::Helper#title derived
// the identical sentence from `lowest_base_price` on the server. Prices moved
// twice that day. DESIGN.md §8.10.
//
// WHY THERE IS A CLIENT TITLE AT ALL. The server renders the correct <title>
// for the document it serves, and that is what a crawler and the first paint
// see. react-helmet is here for the second visit to the <head>: the SPA routes
// in the client, so a visitor who lands on /services and clicks home never
// fetches another document, and nothing but Helmet will change the title.
// Every page under client/gwmc/pages declares one, which is why the home page
// cannot simply drop its own.
//
// WHY NOT READ THE SERVER'S TITLE BACK. `document.title` is the title of the
// document the visitor LANDED on, not of this route: land on /services, click
// home, and the "server title" is the prices page's. A `gwmc:title` meta tag
// would have exactly the same fault, because the server writes it off
// `request.path`. What IS path-independent is `gwmc:catalogue`, which the
// layout writes on every route precisely so that a page the visitor routes to
// later can still read it (MetaTags::Helper#fold_catalogue).
//
// So the figure is lib/page-prices.js' lowest published wash, formatted exactly
// as the server formatted it. That is the same minimum `lowest_base_price`
// takes: CustomerServices::BOOKABLE_BASE_KEYS and
// CustomerCatalogue::BASE_ENTRIES are the same six keys, and page_washes drops
// a wash with no positive price just as `base_services` compacts a retired one.
//
// There is no flash and nothing for a crawler to lose. The server has already
// painted this same sentence into <title>, so on a first load Helmet writes
// the string that is already there.
//
// AND WHEN THE CATALOGUE IS NOT THERE the sentence runs without the figure
// rather than guessing one. That is the rule /services' count sentence already
// follows: a page that cannot see its own catalogue must not invent a number
// for it (DESIGN.md §8.10).
//
// With the extension, because `node --test home-title.test.mjs` resolves this
// import itself, with no bundler in front of it.
import { readLowestWashPrice } from './page-prices.js'

// The sentence is MetaTags::Helper#title's for the '/' route, word for word.
// It is here and not only on the server because only Helmet can set a title
// after a client-side route change; the number in it is still the server's.
export const homeTitle = (from = readLowestWashPrice()) =>
  from
    ? `GoWashMyCar | Mobile car wash & valeting in London, from ${from}`
    : 'GoWashMyCar | Mobile car wash & valeting in London'
